import React, { Fragment } from "react";
import Header from "../header/Header";
import PatientVisits from "../patient-visits/PatientVisits";
import Patients from "../patients/Patients";
export default function PatientDashboard() {
  return (
    <Fragment>
      <Header />
      <PatientVisits category={"clinic"} study_type="" />
      <Patients category={"clinic"} study_type="" />
    </Fragment>
  );
}
